// src/pages/Stocks/components/StockSearch/StockSearch.jsx
import React, { useState } from 'react';
import './StockSearch.css';

const StockSearch = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <div className="stock-search">
      <div className="search-input-container">
        <input
          type="text"
          placeholder="Search assets..."
          value={searchTerm}
          onChange={handleChange}
          className="search-input"
        />
        {searchTerm && (
          <button className="clear-search" onClick={handleClear}>
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default StockSearch;